import { Component, Input } from '@angular/core';
import { BenePignoratoImmobile } from '../../../models/immobili/bene-pignorato-immobile';

@Component({
    selector: '[bene_immobile_entity_view]',
  templateUrl: 'bene-immobile-entity-view.component.html',
})

export class BeneImmobileEntityViewComponent {
  @Input()
  element: BenePignoratoImmobile;
}
